import React, { useState, useEffect } from 'react'
import './Authentication.scss'
import { useNavigate } from 'react-router-dom'
import { Dropdown, Modal, Form, Toast } from 'react-bootstrap'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import { useDispatch, useSelector } from 'react-redux';
import { civilStateTypeList, educationTypeList, getCityList, getComuneList, getCountryList, getRegionList, getProvinciaList, getStateList } from '../redux/survey/survey.actions';
import { updateUserProfileAction } from '../redux/attemptSurvey/attemptSurvey.actions';
import { toast } from 'react-toastify'
import './DatePickerCustom.scss';
import Select from 'react-select'

export default function CompleteProfile() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { civilStateType, educationType, countries, states, cities, regions, provincias, comunes } = useSelector((state) => state.surveyInfo);
    const [showInfo, setShowInfo] = useState({
        dob: true,
        nation: true,
        state: true,
        city: true,
        civilState: true,
        education: true
    });
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedGender, setSelectedGender] = useState('');
    const [selectedNation, setSelectedNation] = useState({ id: '', name: '' });
    const [selectedState, setSelectedState] = useState({ id: '', name: '' });
    const [selectedCity, setSelectedCity] = useState({ id: '', name: '' });
    const [selectedEducation, setSelectedEducation] = useState({ id: '', name: '' });
    const [selectedCivilState, setSelectedCivilState] = useState({ id: '', name: '' });
    const [selectedRegion, setSelectedRegion] = useState({ id: '', name: '' });
    const [selectedProvincia, setSelectedProvincia] = useState({ id: '', name: '' });
    const [selectedComune, setSelectedComune] = useState({ id: '', name: '' });
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [showNationModal, setShowNationModal] = useState(false);
    const [showStateModal, setShowStateModal] = useState(false);
    const [showCityModal, setShowCityModal] = useState(false);
    const [showEducationModal, setShowEducationModal] = useState(false);
    const [showCivilStateModal, setShowCivilStateModal] = useState(false);
    const [showProvinciaModal, setShowProvinciaModal] = useState(false);
    const [showComuneModal, setShowComuneModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // Store all data in variables for easy filtering
    const [filteredCivilStateOptions, setFilteredCivilStateOptions] = useState([]);
    const [filteredEducationOptions, setFilteredEducationOptions] = useState([]);
    const [filteredCountries, setFilteredCountries] = useState([]);
    const [filteredRegions, setFilteredRegions] = useState([]);
    const [filteredProvinces, setFilteredProvinces] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [filteredComunes, setFilteredComunes] = useState([]);

    const toggleInfo = (field) => {
        setShowInfo(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const filterItems = (items, type = 'type') => {
        if (!searchQuery) return items;

        return items?.filter(item => {
            const searchFields = [
                item[type]?.toLowerCase(),
                item[`${type}_en`]?.toLowerCase(),
                item.name?.toLowerCase(),
                item.type?.toLowerCase()
            ];

            return searchFields.some(field =>
                field && field.includes(searchQuery.toLowerCase())
            );
        });
    };

    const filterLocationItems = (items) => {
        if (!searchQuery) return items;

        return items?.filter(item => {
            // For Italian regions
            if (item?.DescrRegione) {
                return item.DescrRegione.toLowerCase().includes(searchQuery.toLowerCase());
            }
            // For Italian provincias
            if (item?.DescrProvincia) {
                return item.DescrProvincia.toLowerCase().includes(searchQuery.toLowerCase());
            }
            // For Italian communes
            if (item?.DescrComune) {
                return item.DescrComune.toLowerCase().includes(searchQuery.toLowerCase());
            }
            // For other locations
            return item?.name?.toLowerCase().includes(searchQuery?.toLowerCase());
        });
    };

    useEffect(() => {
        dispatch(civilStateTypeList());
        dispatch(educationTypeList());
        dispatch(getCountryList());
        dispatch(getRegionList());

        if (selectedNation?.id) {
            dispatch(getStateList(selectedNation?.id));
        }
        if (selectedState?.id) {
            dispatch(getCityList(selectedState?.id));
        }
        if (selectedRegion?.IdRegione || selectedRegion?.id) {
            dispatch(getProvinciaList(selectedRegion?.IdRegione || selectedRegion?.id));
        }
        if (selectedProvincia?.IdProvincia || selectedProvincia?.id) {
            dispatch(getComuneList(selectedProvincia?.IdProvincia || selectedProvincia?.id));
        }
    }, [dispatch, selectedNation?.id, selectedState?.id, selectedRegion?.IdRegione, selectedRegion?.id, selectedProvincia?.IdProvincia, selectedProvincia?.id]);

    useEffect(() => {
        // Update filtered options when data or search query changes
        setFilteredCivilStateOptions(filterItems(civilStateType));
        setFilteredEducationOptions(filterItems(educationType));
        setFilteredCountries(filterLocationItems(countries));
        setFilteredStates(filterLocationItems(states));
        setFilteredCities(filterLocationItems(cities));
        setFilteredRegions(filterLocationItems(regions));
        setFilteredProvinces(filterLocationItems(provincias));
        setFilteredComunes(filterLocationItems(comunes));
    }, [civilStateType, educationType, countries, states, cities, regions, provincias, comunes, searchQuery]);

    // Reset state and city when nation changes
    useEffect(() => {
        if (selectedNation?.id) {
            setSelectedState({ id: '', name: '' });
            setSelectedCity({ id: '', name: '' });
            setSelectedRegion({ id: '', name: '' });
            setSelectedProvincia({ id: '', name: '' });
            setSelectedComune({ id: '', name: '' });
        }
    }, [selectedNation]);

    // Reset city when state changes
    useEffect(() => {
        if (selectedState?.id) {
            setSelectedCity({ id: '', name: '' });
        }
    }, [selectedState]);

    // Reset comune when provincia changes
    useEffect(() => {
        if (selectedProvincia?.id) {
            setSelectedComune({ id: '', name: '' });
        }
    }, [selectedProvincia]);

    // Reset provincia when region changes
    useEffect(() => {
        if (selectedRegion?.id) {
            setSelectedProvincia({ id: '', name: '' });
            setSelectedComune({ id: '', name: '' });
        }
    }, [selectedRegion]);

    // Format date to ISO string with timezone
    const formatDateForDB = (date) => {
        if (!date) return null;
        // Convert date to YYYY-MM-DD format
        // return date.toISOString();
        return date.toISOString().split('T')[0];
    };

    const validateFields = () => {
        const isItalian = localStorage.getItem('language') === 'Italian';

        if (!selectedGender) {
            setToastMessage(isItalian ? 'Seleziona il genere' : 'Please select Gender');
            setShowToast(true);
            return false;
        }
        if (!selectedDate) {
            setToastMessage(isItalian ? 'Seleziona la data di nascita' : 'Please select Date of Birth');
            setShowToast(true);
            return false;
        }

        if (!selectedNation.id) {
            setToastMessage(isItalian ? 'Seleziona la nazione' : 'Please select Nation');
            setShowToast(true);
            return false;
        }

        // For Italian users, check region, provincia, comune
        if (selectedNation.id === "107") {
            if (!selectedRegion.id && !selectedRegion.IdRegione) {
                setToastMessage(isItalian ? 'Seleziona la regione' : 'Please select Region');
                setShowToast(true);
                return false;
            }
            if (!selectedProvincia.id && !selectedProvincia.IdProvincia) {
                setToastMessage(isItalian ? 'Seleziona la provincia' : 'Please select Province');
                setShowToast(true);
                return false;
            }
            if (!selectedComune.id && !selectedComune.IdComune) {
                setToastMessage(isItalian ? 'Seleziona il comune' : 'Please select City');
                setShowToast(true);
                return false;
            }
        } else {
            // For non-Italian users, check state and city
            if (!selectedState.id) {
                setToastMessage(isItalian ? 'Seleziona lo stato' : 'Please select State');
                setShowToast(true);
                return false;
            }
            if (!selectedCity.id) {
                setToastMessage(isItalian ? 'Seleziona la città' : 'Please select City');
                setShowToast(true);
                return false;
            }
        }

        if (!selectedCivilState.name) {
            setToastMessage(isItalian ? 'Seleziona lo stato civile' : 'Please select Civil State');
            setShowToast(true);
            return false;
        }
        if (!selectedEducation.name) {
            setToastMessage(isItalian ? "Seleziona l'istruzione" : 'Please select Education');
            setShowToast(true);
            return false;
        }
        return true;
    };

    const handleSave = () => {
        if (!validateFields()) {
            return;
        }

        // const currentDate = new Date().toLocaleDateString();
        const currentDate = new Date().toISOString().split('T')[0]; // Format as YYYY-MM-DD

        let profileData = {
            dob: {
                date: formatDateForDB(selectedDate),
                updatedAt: currentDate,
                isVisible: showInfo.dob
            },
            gender: {
                name: selectedGender,
                updatedAt: currentDate,
                isVisible: true
            },
            nation_country: {
                id: selectedNation.id,
                updatedAt: currentDate,
                isVisible: showInfo.nation
            },
            civilState: {
                name: selectedCivilState.name,
                updatedAt: currentDate,
                isVisible: showInfo.civilState
            },
            education: {
                name: selectedEducation.name,
                updatedAt: currentDate,
                isVisible: showInfo.education
            }
        };

        // Add location data based on country
        if (selectedNation.id === "107") {
            // For Italy
            profileData = {
                ...profileData,
                region: {
                    id: selectedRegion.IdRegione || selectedRegion.id,
                    name: selectedRegion.DescrRegione || selectedRegion.name,
                    updatedAt: currentDate,
                    isVisible: showInfo.state
                },
                provincia: {
                    id: selectedProvincia.IdProvincia || selectedProvincia.id,
                    name: selectedProvincia.DescrProvincia || selectedProvincia.name,
                    sigla: selectedProvincia.SiglaProvincia,
                    updatedAt: currentDate,
                    isVisible: showInfo.city
                },
                comune: {
                    id: selectedComune.IdComune || selectedComune.id,
                    name: selectedComune.DescrComune || selectedComune.name,
                    latitude: selectedComune.ComLatitudine,
                    longitude: selectedComune.ComLongitudine,
                    updatedAt: currentDate,
                    isVisible: showInfo.city
                }
            };
        } else {
            // For other countries
            profileData = {
                ...profileData,
                region_state: {
                    id: selectedState.id,
                    updatedAt: currentDate,
                    isVisible: showInfo.state
                },
                city: {
                    id: selectedCity.id,
                    updatedAt: currentDate,
                    isVisible: showInfo.city
                }
            };
        }

        dispatch(updateUserProfileAction(profileData));
        navigate('/save-confirm');
    };

    const ModalComponent = ({ show, onHide, title, items, onSelect, selectedValue }) => (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Select
                    options={items?.map(item => ({
                        value: item._id,
                        label: localStorage.getItem('language') === 'Italian' ? item.type : item.type_en
                    }))}
                    placeholder={localStorage.getItem('language') === 'Italian' ? 'Cerca...' : 'Search...'}
                    value={items?.find(item => item._id === selectedValue.id)}
                    onChange={(selected) => {
                        const selectedItem = items.find(item => item._id === selected.value);
                        onSelect({
                            id: selectedItem._id,
                            name: localStorage.getItem('language') === 'Italian' ? selectedItem.type : selectedItem.type_en
                        });
                        onHide();
                        if (title === "Select Education") {
                            setShowInfo(prev => ({ ...prev, education: true }));
                        } else if (title === "Select Civil State") {
                            setShowInfo(prev => ({ ...prev, civilState: true }));
                        }
                    }}
                    filterOption={(option, inputValue) => {
                        return option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase()) || false
                    }}
                    className="mb-3"
                />
            </Modal.Body>
        </Modal>
    );

    const LocationModalComponent = ({ show, onHide, title, items, onSelect, selectedValue }) => (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Select
                    options={items?.map(item => {
                        // For Italian regions
                        if (item.IdRegione && item.DescrRegione) {
                            return {
                                value: item.IdRegione,
                                label: item.DescrRegione
                            };
                        }
                        // For Italian  s
                        if (item.IdProvincia && item.DescrProvincia) {
                            return {
                                value: item.DescrProvincia,
                                label: `${item.DescrProvincia}`
                            };
                        }
                        // For Italian communes
                        if (item.IdComune && item.DescrComune) {
                            return {
                                value: item.IdComune,
                                label: item.DescrComune
                            };
                        }
                        // For other locations
                        return {
                            value: item.id,
                            label: item.name || item.label
                        };
                    })}
                    placeholder={localStorage.getItem('language') === 'Italian' ? 'Cerca...' : 'Search...'}
                    onChange={(selected) => {
                        const selectedItem = items.find(item =>
                            (item.IdRegione && item.IdRegione === selected.value) ||
                            (item.DescrProvincia && item.DescrProvincia === selected.value) ||
                            (item.DescrComune && item.DescrComune === selected.label) ||
                            item.id === selected.value
                        );
                        if (selectedItem?.IdRegione) {
                            onSelect(selectedItem);
                        } else if (selectedItem?.IdProvincia) {
                            onSelect(selectedItem);
                        } else if (selectedItem?.IdComune) {
                            onSelect(selectedItem);
                        } else {
                            onSelect({ id: selectedItem?.id, name: selectedItem?.name });
                        }

                        onHide();
                        if (title === "Select Nation") {
                            setShowInfo(prev => ({ ...prev, nation: true }));
                        } else if (title === "Select State" || title === "Select Region") {
                            setShowInfo(prev => ({ ...prev, state: true }));
                        } else if (title === "Select City" || title === "Select Province" || title === "Select Comune") {
                            setShowInfo(prev => ({ ...prev, city: true }));
                        }
                    }}
                    filterOption={(option, inputValue) => {
                        return option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase()) || false
                    }}
                    className="mb-3"
                />
            </Modal.Body>
        </Modal>
    );

    const isItalian = localStorage.getItem('language') === 'Italian';

    const handleLocationClick = (type) => {
        if (!selectedNation.id) {
            setToastMessage(isItalian ? 'Scegli prima la Nazione' : 'Choose your Nation first');
            setShowToast(true);
            return;
        }

        if (type === 'state') {
            setShowStateModal(true);
        } else if (type === 'city') {
            setShowCityModal(true);
        } else if (type === 'region') {
            setShowStateModal(true);
        } else if (type === 'provincia') {
            setShowProvinciaModal(true);
        } else if (type === 'comune') {
            setShowComuneModal(true);
        }
    };

    return (
        <div className='complete_profile'>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={3000}
                autohide
                style={{
                    position: 'fixed',
                    backgroundColor: 'red',
                    color: 'white',
                    top: 20,
                    right: 20,
                    zIndex: 9999
                }}
            >
                <Toast.Body style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {toastMessage}
                    <button
                        onClick={() => setShowToast(false)}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            color: 'white',
                            cursor: 'pointer',
                            marginLeft: '10px'
                        }}
                    >
                        {isItalian ? 'Annulla' : 'Cancel'}
                    </button>
                </Toast.Body>
            </Toast>

            <div className="heading">
                <div className="back" onClick={() => {
                    navigate('/auth')
                }}>
                    <img src={`${process.env.PUBLIC_URL}/images/survey/back.png`} alt="" />
                </div>
                <div className="title">{isItalian ? 'Completa il profilo' : 'Complete Profile'}</div>
                <div className=""></div>
            </div>

            <div className="who_are_you">
                <div className="title">{isItalian ? 'Chi sei?' : 'Who are you?'}</div>
                <div className="input_container">
                    <label htmlFor="male">
                        <input
                            type="radio"
                            name="gender"
                            id="male"
                            onChange={() => setSelectedGender('male')}
                            checked={selectedGender === 'male'}
                        />
                        <div className="select_gender">
                            <div className="tick">
                                <img src={`${process.env.PUBLIC_URL}/images/survey/tick.png`} alt="" />
                            </div>
                        </div>
                        <div className="name">{isItalian ? 'Maschio' : 'Male'}</div>
                    </label>
                    <label htmlFor="female">
                        <input
                            type="radio"
                            name="gender"
                            id="female"
                            onChange={() => setSelectedGender('female')}
                            checked={selectedGender === 'female'}
                        />
                        <div className="select_gender female">
                            <div className="tick">
                                <img src={`${process.env.PUBLIC_URL}/images/survey/tick.png`} alt="" />
                            </div>
                        </div>
                        <div className="name">{isItalian ? 'Femmina' : 'Female'}</div>
                    </label>
                </div>
            </div>

            <div className="details_wrapper">
                <div className="details_row">
                    <div className="key">
                        <div className="icon" onClick={() => toggleInfo('dob')} style={{ cursor: 'pointer' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/${showInfo.dob ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                        </div>
                        {isItalian ? 'Data di nascita' : 'Date of Birth'}
                    </div>
                    <div className="value grey" onClick={() => setShowDatePicker(true)}>
                        {selectedDate ? selectedDate.toLocaleDateString() : 'DD - MM - YYYY'}
                        <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                    </div>
                    <Modal show={showDatePicker} onHide={() => setShowDatePicker(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{isItalian ? 'Seleziona la data di nascita' : 'Select Date of Birth'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="d-flex justify-content-center">
                                <DatePicker
                                    onChange={(date) => {
                                        setSelectedDate(date);
                                        setShowDatePicker(false);
                                        setShowInfo(prev => ({ ...prev, dob: true }));
                                    }}
                                    value={selectedDate}
                                    maxDate={new Date()}
                                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100))}
                                    yearPlaceholder="yyyy"
                                    monthPlaceholder="mm"
                                    dayPlaceholder="dd"
                                    format="dd-MM-yyyy"
                                    calendarType="ISO 8601"
                                    clearIcon={null}
                                    className="custom-date-picker"
                                />
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>

                <div className="details_row">
                    <div className="key">
                        <div className="icon" onClick={() => toggleInfo('nation')} style={{ cursor: 'pointer' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/${showInfo.nation ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                        </div>
                        {isItalian ? 'Nazione' : 'Nation'}
                    </div>
                    <div className="value" onClick={() => setShowNationModal(true)}>
                        {selectedNation.name || (isItalian ? 'Seleziona la nazione' : 'Select Nation')}
                        <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                    </div>
                    <LocationModalComponent
                        show={showNationModal}
                        onHide={() => setShowNationModal(false)}
                        title={isItalian ? 'Seleziona la nazione' : 'Select Nation'}
                        items={filteredCountries}
                        onSelect={setSelectedNation}
                        selectedValue={selectedNation}
                    />
                </div>

                {selectedNation?.id === "107" ? (
                    <>
                        <div className="details_row">
                            <div className="key">
                                <div className="icon" onClick={() => toggleInfo('state')} style={{ cursor: 'pointer' }}>
                                    <img src={`${process.env.PUBLIC_URL}/images/${showInfo.state ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                                </div>
                                {isItalian ? 'Regione' : 'Region'}
                            </div>
                            <div className="value" onClick={() => handleLocationClick('region')}>
                                {selectedRegion.DescrRegione || selectedRegion.name || (isItalian ? 'Seleziona la regione' : 'Select Region')}
                                <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                            </div>
                            <LocationModalComponent
                                show={showStateModal}
                                onHide={() => setShowStateModal(false)}
                                title={isItalian ? 'Seleziona la regione' : 'Select Region'}
                                items={filteredRegions}
                                onSelect={setSelectedRegion}
                                selectedValue={selectedRegion}
                            />
                        </div>

                        <div className="details_row">
                            <div className="key">
                                <div className="icon" onClick={() => toggleInfo('city')} style={{ cursor: 'pointer' }}>
                                    <img src={`${process.env.PUBLIC_URL}/images/${showInfo.city ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                                </div>
                                {isItalian ? 'Provincia' : 'Province'}
                            </div>
                            <div className="value" onClick={() => handleLocationClick('provincia')}>
                                {selectedProvincia.DescrProvincia || selectedProvincia.name || (isItalian ? 'Seleziona la provincia' : 'Select Province')}
                                <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                            </div>
                            <LocationModalComponent
                                show={showProvinciaModal}
                                onHide={() => setShowProvinciaModal(false)}
                                title={isItalian ? 'Seleziona la provincia' : 'Select Province'}
                                items={filteredProvinces}
                                onSelect={setSelectedProvincia}
                                selectedValue={selectedProvincia}
                            />
                        </div>

                        <div className="details_row">
                            <div className="key">
                                <div className="icon" onClick={() => toggleInfo('city')} style={{ cursor: 'pointer' }}>
                                    <img src={`${process.env.PUBLIC_URL}/images/${showInfo.city ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                                </div>
                                {isItalian ? 'Comune' : 'City'}
                            </div>
                            <div className="value" onClick={() => handleLocationClick('comune')}>
                                {selectedComune?.DescrComune || selectedComune?.name || (isItalian ? 'Seleziona il comune' : 'Select City')}
                                <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                            </div>
                            <LocationModalComponent
                                show={showComuneModal}
                                onHide={() => setShowComuneModal(false)}
                                title={isItalian ? 'Seleziona il comune' : 'Select City'}
                                items={filteredComunes}
                                onSelect={setSelectedComune}
                                selectedValue={selectedComune}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="details_row">
                            <div className="key">
                                <div className="icon" onClick={() => toggleInfo('state')} style={{ cursor: 'pointer' }}>
                                    <img src={`${process.env.PUBLIC_URL}/images/${showInfo.state ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                                </div>
                                {isItalian ? 'Stato' : 'State'}
                            </div>
                            <div className="value" onClick={() => handleLocationClick('state')}>
                                {selectedState.name || (isItalian ? 'Seleziona lo stato' : 'Select State')}
                                <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                            </div>
                            <LocationModalComponent
                                show={showStateModal}
                                onHide={() => setShowStateModal(false)}
                                title={isItalian ? 'Seleziona lo stato' : 'Select State'}
                                items={filteredStates}
                                onSelect={setSelectedState}
                                selectedValue={selectedState}
                            />
                        </div>

                        <div className="details_row">
                            <div className="key">
                                <div className="icon" onClick={() => toggleInfo('city')} style={{ cursor: 'pointer' }}>
                                    <img src={`${process.env.PUBLIC_URL}/images/${showInfo.city ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                                </div>
                                {isItalian ? 'Città' : 'City'}
                            </div>
                            <div className="value" onClick={() => handleLocationClick('city')}>
                                {selectedCity.name || (isItalian ? 'Seleziona la città' : 'Select City')}
                                <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                            </div>
                            <LocationModalComponent
                                show={showCityModal}
                                onHide={() => setShowCityModal(false)}
                                title={isItalian ? 'Seleziona la città' : 'Select City'}
                                items={filteredCities}
                                onSelect={setSelectedCity}
                                selectedValue={selectedCity}
                            />
                        </div>
                    </>
                )}

                <div className="details_row no_border">
                    <div className="key">
                        <div className="icon" onClick={() => toggleInfo('civilState')} style={{ cursor: 'pointer' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/${showInfo.civilState ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                        </div>
                        {isItalian ? 'Stato Civile' : 'Civil State'}
                    </div>
                    <div className="value" onClick={() => setShowCivilStateModal(true)}>
                        {selectedCivilState.name || (isItalian ? 'Seleziona lo stato civile' : 'Select Civil State')}
                        <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                    </div>
                    <ModalComponent
                        show={showCivilStateModal}
                        onHide={() => setShowCivilStateModal(false)}
                        title={isItalian ? 'Seleziona lo stato civile' : 'Select Civil State'}
                        items={filteredCivilStateOptions}
                        onSelect={setSelectedCivilState}
                        selectedValue={selectedCivilState}
                    />
                </div>

                <div className="details_row no_border">
                    <div className="key">
                        <div className="icon" onClick={() => toggleInfo('education')} style={{ cursor: 'pointer' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/${showInfo.education ? 'password_show.png' : 'password_hide.png'}`} alt="" />
                        </div>
                        {isItalian ? 'Istruzione' : 'Education'}
                    </div>
                    <div className="value" onClick={() => setShowEducationModal(true)}>
                        {selectedEducation.name || (isItalian ? 'Seleziona istruzione' : 'Select Education')}
                        <img src={`${process.env.PUBLIC_URL}/images/right_arrow.svg`} alt="" />
                    </div>
                    <ModalComponent
                        show={showEducationModal}
                        onHide={() => setShowEducationModal(false)}
                        title={isItalian ? 'Seleziona istruzione' : 'Select Education'}
                        items={filteredEducationOptions}
                        onSelect={setSelectedEducation}
                        selectedValue={selectedEducation}
                    />
                </div>
            </div>

            <div className="note">
                <span>Note: </span>

                <div className="note_text"><img src={`${process.env.PUBLIC_URL}/images/password_hide.png`} alt="" />{isItalian ? 'Questa informazione non è visibile pubblicamente' : 'This information is not visible publicly'}</div>
                <div className="note_text"><img src={`${process.env.PUBLIC_URL}/images/password_show.png`} alt="" />{isItalian ? 'Questa informazione è visibile pubblicamente' : 'This information is visible publicly'}</div>
            </div>
            <div className="note" style={{ marginBottom: '-35px' }}><img src={`${process.env.PUBLIC_URL}/images/iicon.svg`} height={15} width={15} alt="" style={{ marginRight: '5px' }} /> {isItalian ? 'Puoi nascondere o mostrare le informazioni del tuo profilo cliccando sulle icone relative.' : 'You can hide or show your profile information by clicking on the corresponding icons.'}</div>
            <div className="action">
                <button onClick={handleSave}>{isItalian ? 'Salva' : 'Save'}</button>
            </div>
        </div >
    )
}
